import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { BASE_URL } from './../../Environment';

function Invoice() {
    const { id } = useParams();

    useEffect(() => {
        document.title = 'Infomart | Agent Invoice'; 
        window.location.href = `${BASE_URL}/agent/invoice/${id}`;
    }, []);

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            fontSize: '16px',
            color: '#333'
        }}>
            Loading Invoice...
        </div>
    );
}

export default Invoice; 